/**
 * The shared skew-and-slide geometry of the three tricolour panels.
 *
 * The flags are parallelograms: each `.long-flag` is skewed 18.5°, and its contents are
 * skewed back by the same amount so the text stays upright. Sliding a panel out means
 * translating it `flagOutExtent` px while holding that skew — which is why the skew is a
 * one-frame `steps(1)` tween rather than a static transform: anime.js overwrites the
 * whole `transform`, so every animation has to restate it.
 */
export const flagGeometry = {
    /** How far a panel slides out from behind the 20 px tricolour stripe. */
    flagOutExtent: 220,
    linearOutDuration: 550,

    skewProperties: {
        value: 18.5,
        easing: 'steps(1)',
        duration: 1,
    },
    skewPropertiesNegative: {
        value: -18.5,
        easing: 'steps(1)',
        duration: 1,
    },

    futureRunAnimationDuration: 200,
};

window.flagGeometry = flagGeometry;
